import React, { useEffect, useRef, useState } from "react";
import CustomModal from "../Common/CustomModal";
import {
  Box,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { CustomInput } from "../Common/CustomInputs";
import { Email, Send } from "@mui/icons-material";
import axiosInstance from "../../utils/config/config";
import { colors } from "../../theme/theme";

const CommentsModal = ({
  open,
  handleClose,
  sessionId,
  setloading,
  seterrorState,
  setsuccess,
}) => {
  const theme = useTheme();
  const [comment, setComment] = useState("");
  const commentsRef = useRef(null);

  const [allComments, setAllComments] = useState([]);

  const fetchComments = async () => {
    try {
      const response = await axiosInstance.get(
        `sessionexchange/comment/getAll?sessionExchangeId=${sessionId}`
      );
      setAllComments(response.data?.comments);
    } catch (error) {
      console.error(error);
    }
  };

  const onSubmit = async () => {
    seterrorState({ error: false, errorMsg: "" });

    if (!comment) {
      seterrorState({ error: true, errorMsg: "Please fill all the fields" });
      return;
    }

    try {
      const response = await axiosInstance.post(
        "sessionexchange/comment/create",
        {
          content: comment,
          sessionExchangeId: sessionId,
        }
      );

      if (response.data) {
        setsuccess(true);
      }
      setloading(false);
    } catch (error) {
      setloading(false);
      seterrorState({ error: true, message: error.message });
    } finally {
      setloading(false);
      fetchComments();
      setComment("");
    }
  };

  useEffect(() => {
    if (sessionId) {
      fetchComments();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    if (commentsRef.current) {
      commentsRef.current.scrollTop = commentsRef.current.scrollHeight;
    }
  }, [allComments]);

  return (
    <CustomModal
      open={open}
      handleClose={handleClose}
      title={"Comments"}
      noBtns
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          position: "relative",
          px: 4,
        }}
      >
        <Box
          ref={commentsRef}
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            padding: "16px",
            my: 2,
            scrollbarWidth: "thin",
            scrollbarColor: `#576874 transparent`,
          }}
        >
          <Typography sx={[theme.heading2, { color: colors.primary }]}>
            Comments
          </Typography>
          {allComments?.length === 0 && (
            <Typography
              sx={{
                fontSize: "16px",
                color: colors.primary,
                fontFamily: "'Quicksand', sans-serif",
                mt: 4,
                textAlign: "center",
              }}
            >
              No comments yet.
            </Typography>
          )}
          {allComments.map((comment) => (
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              key={comment.id}
              alignItems={"center"}
            >
              <Stack
                direction={"row"}
                alignItems={"center"}
                spacing={2}
                mt={2}
                key={comment.id}
              >
                <Box
                  sx={{
                    height: "40px",
                    width: "40px",
                    borderRadius: "50%",
                    backgroundColor: "#F4F4F4",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "16px",
                      color: colors.primary,
                      fontWeight: "800",
                      textTransform: "uppercase",
                      textAlign: "center",
                      lineHeight: "40px",
                      fontFamily: "'Gotham', sans-serif",
                    }}
                  >
                    {comment?.user?.email?.charAt(0)}
                  </Typography>
                </Box>
                <Stack direction={"column"}>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      color: colors.primary,
                      fontFamily: "'Quicksand', sans-serif",
                    }}
                  >
                    {comment?.user?.firstName}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      color: colors.primary,
                      fontFamily: "'Quicksand', sans-serif",
                    }}
                  >
                    {comment?.content}
                  </Typography>
                </Stack>
              </Stack>

              <IconButton
                sx={{
                  bgcolor: colors.primary,
                  ":hover": {
                    bgcolor: colors.primary,
                  },
                }}
                onClick={() => {
                  window.open(
                    `mailto:${comment?.user?.email}?subject=Session%20Exchange%20Request&body=Hello%20${comment?.user?.firstName}`
                  );
                }}
              >
                <Email
                  sx={{ color: theme.palette.text.primary, fontSize: "14px" }}
                />
              </IconButton>
            </Stack>
          ))}
        </Box>

        <Box
          sx={{
            position: "sticky",
            bottom: 10,
            left: 0,
            right: 0,
          }}
        >
          <CustomInput
            placeholder="Enter your comment"
            value={comment}
            setValue={setComment}
            Icon={Send}
            rightIcon
            bR={"10px"}
            width={"100%"}
            onClick={onSubmit}
            color={colors.primary}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                onSubmit();
              }
            }}
          />
        </Box>
      </Box>
    </CustomModal>
  );
};

export default CommentsModal;
